<template>
  <div class="tcdc-custom-marker" :style="{ 'background-color': color ? color : '#2e8037' }">
    <div class="tcdc-bounce1" :style="{ 'background-color': bounceColor ? bounceColor : '#2e8037' }"></div>
    <div class="tcdc-bounce2" :style="{ 'background-color': bounceColor ? bounceColor : '#2e8037' }"></div>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#2e8037'
    },
    bounceColor: {
      type: String,
      default: '#2e8037'
    }
  }
};
</script>

<style lang="scss" scoped>
.tcdc-custom-marker {
  width: 10px;
  height: 10px;
  border-radius: 100px;
  position: relative;
}

.tcdc-bounce1,
.tcdc-bounce2 {
  width: 40px;
  height: 40px;
  margin-left: -15px;
  margin-top: -15px;
  border-radius: 100px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  animation: tcdc-custom-marker 2s infinite;
  -webkit-animation: tcdc-custom-marker 2s infinite;
}
.tcdc-bounce2 {
  animation-delay: -1s;
}

@keyframes tcdc-custom-marker {
  from {
    transform: scale(0);
    -webkit-transform: scale(0);
    opacity: 1;
  }
  to {
    transform: scale(1);
    -webkit-transform: scale(1);
    opacity: 0;
  }
}
</style>
